import React from 'react';

interface ProjectCardProps {
  title: string;
  description: React.ReactNode;
  technologies: string;
  mediaType: 'image' | 'video';
  mediaSrc: string;
  mediaAlt?: string;
  links?: { label: string; href: string }[];
  reverse?: boolean;
  index?: number;
}

export default function ProjectCard({
  title,
  description,
  technologies,
  mediaType,
  mediaSrc,
  mediaAlt = '',
  links = [],
  index = 0,
}: ProjectCardProps) {
  // Split comma-separated tech string into individual pills
  const techList = technologies.split(',').map(t => t.trim());

  return (
    <div className="project-card">
      <div className="project-media">
        {mediaType === 'image' ? (
          <img src={mediaSrc} alt={mediaAlt} loading="lazy" />
        ) : (
          <video controls>
            <source src={mediaSrc} type="video/mp4" />
          </video>
        )}
      </div>

      <div className="project-content">
        <h3>{title}</h3>
        <p className="project-desc">{description}</p>

        {/* Tech pills */}
        <div className="project-tech">
          {techList.map((tech, i) => (
            <span key={i} className="tech-pill">{tech}</span>
          ))}
        </div>

        {links.length > 0 && (
          <div className="project-links">
            {links.map((link, i) => (
              <a key={i} href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label === 'Live' ? '↗ Live' : '⌥ Source'}
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}